module.exports = __webpack_public_path__ + "static/media/mic4.fed3c06b.svg";


//////////////////
// WEBPACK FOOTER
// ./src/static/icons/mic4.svg
// module id = 3208
// module chunks = 7